import { useMutation } from '@apollo/client';
import { UPDATE_QUESTIONNAIRE_RESPONSE } from '../gqlSchemes/updateQuestionnaireResponse';

interface UpdateQuestionnaireResponseInput {
  questionnaireResponseId: string;
  questionResponsesJson: string;
  reasonForAmendment: string;
}

interface UpdateQuestionnaireResponseVariables {
  record: UpdateQuestionnaireResponseInput;
}

export const useUpdateQuestionnaireResponse = () => {
  const [updateQuestionnaireResponse, { loading, error, data }] = useMutation<
    any,
    UpdateQuestionnaireResponseVariables
  >(UPDATE_QUESTIONNAIRE_RESPONSE);

  return {
    updateQuestionnaireResponse,
    loading,
    error,
    data,
  };
};

export default useUpdateQuestionnaireResponse;
